import { BlockApi } from "../../../../Shared/Constants/api";
import axiosInstance from "../../../../Shared/Utils/axiosInstance";

export const deleteBlockApi = async (id) => {
  try {
    let response = await axiosInstance.delete(`${BlockApi}/${id}`);

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
